import { logInfo } from '../../logger';
import { goToLoginScreen } from '../go-to-login-screen/goToLoginScreen';
import { EUserTokenType } from './getUserToken.types';
import { isUserTokenExpired, refreshUserToken } from './getUserToken.web';

export const checkJwtPreInit = async (): Promise<{ shouldContinueInit: boolean }> => {
  const currentPath = window.location.pathname;
  const isOnLoginPage = currentPath.startsWith('/login');

  if (!isOnLoginPage) {
    const jwtInfo = await isUserTokenExpired();
    logInfo('[checkJwtPreInit] jwtInfo (pre-init)', { isExpired: jwtInfo.isExpired, jwtInfo });

    if (jwtInfo.isExpired) {
      if (jwtInfo.tokenType === EUserTokenType.PHOTOSI) {
        goToLoginScreen();
        return { shouldContinueInit: false };
      } else {
        await refreshUserToken();
        logInfo('[checkJwtPreInit] guest token refreshed');
      }
    }
  }

  return { shouldContinueInit: true };
};
